import type { Loc, Region } from "./const.js";

/** 可建單的服務類型（round_trip 停用、point_to_point 新增） */
export const CREATABLE_SERVICE_TYPES = ["airport_pickup", "airport_dropoff", "point_to_point", "charter"] as const;
export type CreatableServiceType = (typeof CREATABLE_SERVICE_TYPES)[number];

/** 計價區域（zone）— 價格表與 POI 的地理單位 */
export const ZONES = [
  { code: "taipei", region: "taiwan", label: { "zh-TW": "台北", "en-US": "Taipei", "zh-CN": "台北" } },
  { code: "new_taipei", region: "taiwan", label: { "zh-TW": "新北", "en-US": "New Taipei", "zh-CN": "新北" } },
  { code: "taoyuan", region: "taiwan", label: { "zh-TW": "桃園", "en-US": "Taoyuan", "zh-CN": "桃园" } },
  { code: "hsinchu", region: "taiwan", label: { "zh-TW": "新竹", "en-US": "Hsinchu", "zh-CN": "新竹" } },
  { code: "kowloon", region: "hongkong", label: { "zh-TW": "九龍", "en-US": "Kowloon", "zh-CN": "九龙" } },
  { code: "new_territories", region: "hongkong", label: { "zh-TW": "新界", "en-US": "New Territories", "zh-CN": "新界" } },
  { code: "hk_island", region: "hongkong", label: { "zh-TW": "港島", "en-US": "HK Island", "zh-CN": "港岛" } },
] as const satisfies readonly { code: string; region: Region; label: Loc }[];
export type ZoneCode = (typeof ZONES)[number]["code"];
export const zoneByCode = (code: string) => ZONES.find((z) => z.code === code);

/** 可下單機場（客戶指定：桃園/松山/香港；KHH 僅留在舊 AIRPORTS 顯示用） */
export const BOOKING_AIRPORT_CODES = ["TPE", "TSA", "HKG"] as const;
export type BookingAirportCode = (typeof BOOKING_AIRPORT_CODES)[number];
export const airportRegion = (code: BookingAirportCode): Region => (code === "HKG" ? "hongkong" : "taiwan");

/** POI 分類 */
export const POI_CATEGORIES = ["hotel", "attraction", "transport"] as const;
export type PoiCategory = (typeof POI_CATEGORIES)[number];

/** 加購項 */
export const ADDON_CODES = ["luggage_sign", "child_seat"] as const;
export type AddonCode = (typeof ADDON_CODES)[number];

/** 匯率表幣別（HKD 為中心幣別，rate 表示 1 HKD = rate × 該幣） */
export const EXCHANGE_CURRENCIES = ["TWD", "KRW", "EUR", "USD", "JPY", "CNY"] as const;
export type ExchangeCurrency = (typeof EXCHANGE_CURRENCIES)[number];

/** 需求方顯示幣別（D10）：一律 HKD，不換算、不維護匯率表。
 *  保留參數與 union 型別，以利未來多幣別/聯盟制擴充；現階段恆回 "HKD"。 */
export const displayCurrencyForRegion = (_agencyRegion: Region): "TWD" | "HKD" => "HKD";

/** 接機預約方式 */
export const BOOKING_MODES = ["by_flight", "by_time"] as const;
export type BookingMode = (typeof BOOKING_MODES)[number];

/** 訂單停點（接機多目的地 / 送機多上車點 / 點對點多停點） */
export type OrderStop = { seq: number; location: string; zone?: ZoneCode; poiId?: number };
/** 訂單加購快照 */
export type OrderAddon = { code: AddonCode; name: string; priceHkd: number };
